import ClientAppConfig from './client/ClientAppConfig';
import StaffListsAppConfig from './staff/StaffListsAppConfig';
import AllAppConfig from './e-commerce/AllAppConfig';
import StaffAppConfig from './e-commerce/StaffAppConfig';
import CustomerAppConfig from './e-commerce/CustomerAppConfig';
import SettingsAppConfig from './settings/SettingsAppConfig';
import BackofficeConfig from './backoffice/BackofficeConfig';
import SupplierAppConfig from './e-commerce/SupplierAppConfig';
import InventoryLookupConfig from './inventory-lookup/InventoryLookupConfig';

const appsConfigs = [
  StaffListsAppConfig,
  AllAppConfig,
  StaffAppConfig,
  CustomerAppConfig,
  ClientAppConfig,
  SettingsAppConfig,
  BackofficeConfig,
  SupplierAppConfig,
  InventoryLookupConfig,
];

export default appsConfigs;
